<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">

				<Row>
					<Col span="9">
					<FormItem label="名称" prop="name" class="">
						<Input v-model="formValidate.name" placeholder="请输入名称" maxlength="32"></Input>
					</FormItem>
					</Col>
					<Col span="5">
					<FormItem label="一级分类" prop="type1" class="" >
						<Select  placeholder="选择分类" v-model="formValidate.type1"  @on-change="onchange1" filterable>
							<Option v-for="item in operComTypes" :key="item.id" :value="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="5">
					<FormItem label="二级分类" prop="type2" class="">
						<Select  placeholder="选择分类" v-model="formValidate.type2"  @on-change="onchange2"   filterable>
							<Option v-for="item in operComTypes2" :key="item.id" :value="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="5">
					<FormItem label="三级分类" prop="operComType.id" class="" >
						<Select v-model="formValidate.operComType.id" placeholder="选择分类" filterable>
							<Option v-for="item in operComTypes3" :key="item.id" :value="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					</Col>
				
				</Row>
				<Row>
						<Col span="5">
					<FormItem label="体积" prop="volume" class="" >
						<Select  placeholder="选择体积" v-model="formValidate.volume"  @on-change="onchange3">
							<Option v-for="item in volumes" :key="item.value" :value="item.value">{{item.name}}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row >
					<Col span="24">
					<FormItem label="宣传短语" prop="title" class="">
						<Input v-model="formValidate.title" placeholder="请输入宣传短语"  maxlength="32"></Input>
					</FormItem>
					</Col>
				</Row>
				<!-- <Row >
					<Col span="24">
					<FormItem label="主治说明"  class=""   prop="actions">
						<Input v-model="formValidate.actions" placeholder="请输入住址说明"  maxlength="64"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row >
					<Col span="24">
					<FormItem label="国药准字号"  class="" prop="norm">
						<Input v-model="formValidate.norm" placeholder="请输入国药准字号" maxlength="64"></Input>
					</FormItem>
					</Col>
				</Row> -->
				<Row>
					<Col span="12">
					<FormItem label="生产厂商" prop="operCommManuId" class="" >
						<Select v-model="formValidate.operCommManuId" placeholder="请选择商家" filterable>
							<Option v-for="item in operCommManus" :key="item.id" :value="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="12">
					<FormItem label="品牌" prop="operCommBrandId" class="">
						<Select v-model="formValidate.operCommBrandId" placeholder="请选择品牌" filterable>
							<Option v-for="item in operCommBrands" :key="item.id" :value="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span="8">
					<FormItem label="进价" prop="purchasingPrice" class="">
						<Input v-model="formValidate.purchasingPrice" type="number" placeholder="请输入进价(单位:元)"></Input>
					</FormItem>
					</Col>
					<Col span="8">
					<FormItem label="售价" prop="sellPrice" class="">
						<Input v-model="formValidate.sellPrice" type="number" placeholder="请输入售价(单位:元)"></Input>
					</FormItem>
					</Col>
					<Col span="8">
					<FormItem label="单位" prop="unit" class="">
						<Input v-model="formValidate.unit" placeholder="请输入单位" maxlength="4"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span="8">
					<FormItem label="商品规格" prop="specification" class="">
						<Input v-model="formValidate.specification" placeholder="请输入商品规格" maxlength="16"></Input>
					</FormItem>
					</Col>
					<Col span="8">
					<FormItem label="商品条形码" prop="barCode" class="">
						<Input v-model="formValidate.barCode" placeholder="请输入商品条形码"  maxlength="32"></Input>
					</FormItem>
					</Col>
					<Col span="8">
					<FormItem label="存储条件"  class="" prop="storage">
						<Input v-model="formValidate.storage" placeholder="请输入存储条件"  maxlength="32"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row class=''>
					<Col span="16">
					<FormItem label="上传图片" class="">
						<!-- <Img @imgFile='imgFile' :size="1"/> -->
						<Imgs @imgFile='imgFile' number='1' :url="url" v-if='isRouterAlive'/>
						<div style="color: red;font-size: 12px;">*咖啡机图片需上传长图,建议尺寸：1120x2000</div>
					</FormItem>

					</Col>
					<!-- <Col span="5">
					<FormItem label="体积" prop="volume" class="" >
						<Select  placeholder="选择体积" v-model="formValidate.volume" >
							<Option v-for="item in volumes" :key="item.id" :value="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					</Col> -->
				</Row>

				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	import Imgs from '@/components/comm/imgs.vue'
	export default {
		data() {
			return {
				volumes:[
					{name:'1',value:'1'},
					{name:'2',value:'2'},
					{name:'3',value:'3'},
					{name:'4',value:'4'},
					{name:'5',value:'5'},
					],
				isRouterAlive:true,
				loading:false, 
				operType:'',
				url:'',
				query: {
					page: 0,
					size: 1000,
					level:0,
					parentId:0
				},
				operCommBrands:[],
				operCommManus:[],
				operComTypes: [],
				operComTypes2: [],
				operComTypes3: [],
				formValidate: {
					type1:'',
					type2:'',
					name: '',
					operComType:{
						id:''
					},
					purchasingPrice: '',
					sellPrice: '',
					img: 'aaa',
					title:'',
					operCommManuId:'',
					operCommBrandId:'',
					specification:'',
					barCode:"",
					unit:'',
					volume:'',
				},
				ruleValidate: {
					type1: [{
						required: true,
						message: '请选择一级分类！！！',
						trigger: 'blur'
					}],
					type2: [{
						required: true,
						message: '请选择二级分类！！！',
						trigger: 'blur'
					}],
					barCode: [{
						required: true,
						message: '商品条形码不能为空！！！',
						trigger: 'blur'
					}],
					specification: [{
						required: true,
						message: '商品规格不能为空！！！',
						trigger: 'blur'
					}],
					operCommManuId: [{
						required: true,
						message: '生产厂商不能为空！！！',
						trigger: 'blur'
					}],
					operCommBrandId: [{
						required: true,
						message: '品牌不能为空！！！',
						trigger: 'blur'
					}],
					// actions: [{
					// 	required: true,
					// 	message: '主治功能不能为空！！！',
					// 	trigger: 'blur'
					// }],
					// norm: [{
					// 	required: true,
					// 	message: '国药准治号不能为空！！！',
					// 	trigger: 'blur'
					// }],
					name: [{
						required: true,
						message: '名称不能为空！！！',
						trigger: 'blur'
					}],
					'operComType.id': [{
						required: true,
						message: '商品类别不能为空！！！',
						trigger: 'blur'
					}],
					purchasingPrice: [{
						required: true,
						message: '进价不能为空！！！',
						trigger: 'blur'
					}],
					sellPrice: [{
						required: true,
						message: '售价不能为空！！！',
						trigger: 'blur'
					}],
					img: [{
						required: true,
						message: '图片不能为空！！！',
						trigger: 'blur',
						type: 'number'
					}],
					title: [{
						required: true,
						message: '宣传短语不能为空！！！',
						trigger: 'blur'
					}],
					
					unit: [{
						required: true,
						message: '单位不能为空！！！',
						trigger: 'blur'
					}],
					volume: [{
						required: true,
						message: '请选择体积！！！',
						trigger: 'blur'
					}],

				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			onchange1(a){
				//查询商品类别
				let _this=this
				let query={
					page: 0,
					size: 1000,
					level:2,
					parentId:a
				}
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComType/page/oper/all',
				    data: query,
					_this: _this,
					success: function(data) {
						_this.operComTypes2 = data.page.content
						
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},onchange2(a){
				//查询商品类别
				let _this=this
				let query={
					page: 0,
					size: 1000,
					level:2,
					parentId:a
				}
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComType/page/oper/all',
				    data: query,
					_this: _this,
					success: function(data) {
						_this.operComTypes3 = data.page.content
						
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
			},
			onchange3(a){
				let _this=this
				_this.formValidate.volume = a
				console.log(a,'这是values')
			},
			handleSubmit(name) {
				
				let _this=this
				 if(this.formValidate.img==''){
					this.$Message.error('请上传图片!');
					return ;
				}
				 if (!(/(^[0-9]\d*$)/.test(_this.formValidate.barCode))) {
				 
				 	this.$Message.error('请输入正确的条形码!');
				 	return;
				 }
				 _this.formValidate.unit=_this.formValidate.unit.trim()
				 _this.formValidate.specification=_this.formValidate.specification.trim()
				_this.formValidate.name=_this.formValidate.name.trim()
				_this.formValidate.title=_this.formValidate.title.trim()
				// _this.formValidate.volume=_this.formValidate.volume.trim()
				this.$refs[name].validate((valid) => {
					console.log(valid,'valid')
					if (valid) {
						let aaa={
							name: _this.formValidate.name,
							operComType: {
								id:_this.formValidate.operComType.id
							},
							volume:_this.formValidate.volume,
							purchasingPrice: _this.formValidate.purchasingPrice*100,
							sellPrice: _this.formValidate.sellPrice*100,
							img:_this.formValidate.img,
							unit:_this.formValidate.unit,
							title:_this.formValidate.title,
							actions:_this.formValidate.actions,
							norm:_this.formValidate.norm,
							operCommManuId:_this.formValidate.operCommManuId,
							operCommBrandId:_this.formValidate.operCommBrandId,
							specification:_this.formValidate.specification,
							barCode:_this.formValidate.barCode,
							storage:_this.formValidate.storage
						}
						
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/oper/operComMerchandise/add',
						    data: aaa,
							_this: _this,
							success: function(data) {
								_this.$Message.success('新增成功！！！');
								// _this.formValidate.name=""
								// _this.formValidate.title=""
								// _this.formValidate.sellPrice=""
								// _this.formValidate.price=""
								// _this.formValidate.unit=""
				               _this.$refs[name].resetFields();
							   _this.$emit('ajaxPage');
							   
							   _this.formValidate.img=''
							   
							   _this.isRouterAlive = false
							   _this.$nextTick(() => (_this.isRouterAlive = true))
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
						
					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
				this.formValidate.img=''
				this.isRouterAlive = false
				this.$nextTick(() => (this.isRouterAlive = true))
			},
			//接收img子组件返回的方法
			imgFile(files) {
				//this.formValidate.img=files
				console.log(files)
				this.formValidate.img=files.substr(0, files.length - 1);  
			},
			ajaxPageBrand() {
				this.loading = true
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/oper/comm/brand/query/oper',
					_this: _this,
					success: function(data) {
						_this.operCommBrands = data.operCommBrands
			
						_this.loading = false
					}
					//假设后台需要的是表单数据这里你就可以更改
				})
			
			},
			
			ajaxPageManu() {
				this.loading = true
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/oper/comm/manu/query/oper',
					_this: _this,
					success: function(data) {
						_this.operCommManus = data.operCommManus
			
						_this.loading = false
					}
					//假设后台需要的是表单数据这里你就可以更改
				})
			
			}
			

		},
		components: {
			Imgs
		},
		created() {
			
			//查询商品类别
			let _this=this
			_this.url=http.url+"/file/img/com"
			http.http({
			    //这里是你自己的请求方式、url和data参数
			    method: 'post',
			    url: http.url + '/oper/operComType/page/oper/all',
			    data: _this.query,
				_this: _this,
				success: function(data) {
					_this.operComTypes = data.page.content
					
					_this.loading = false
				}
			    //假设后台需要的是表单数据这里你就可以更改
			  })
			  _this.ajaxPageBrand()
			  _this.ajaxPageManu()
			
		},
		//设置返回不刷新数据
		beforeRouteLeave(to, from, next) {
			to.meta.keepAlive = true;
			next();
		}, 
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.content {
		margin-left: 10%;
		width: 900px;

	}

	.ivu-form-item {
		margin-bottom: 5px;
	}

	.ivu-row {
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/commodity/comm/add.vue